import React, { useState } from "react";
import a4 from "../Accests/images/about/register.jpg";
import a5 from "../Accests/images/about/ll.jpg";

const AboutDetails = () => {
    const [selectedImage, setSelectedImage] = useState();

    return (
        <div className="w-full bg-white dark:bg-gray-900 py-16 px-4 relative mt-10">
            <div className="max-w-6xl mx-auto">
                {/* Heading */}
                <h2 className="text-4xl md:text-5xl font-bold text-green-600 dark:text-green-400 text-center mb-8">
                    Discover More About Us
                </h2>

                {/* Paragraphs */}
                <div className="text-lg md:text-xl text-gray-700 dark:text-gray-200 leading-relaxed space-y-6 text-justify">
                    <p>
                        No Limit Tour Randombe was born from a deep love for Sri Lanka’s rich heritage, pristine landscapes, and welcoming culture. We are more than just a travel agency – we are storytellers, guides, and friends on your journey to discover the best of our island.
                    </p>
                    <p>
                        Our mission is to provide authentic, sustainable travel experiences that leave lasting impressions. From untouched beaches and lush rainforests to ancient temples and vibrant festivals, our curated tours are designed to immerse you in true Sri Lankan life.
                    </p>
                    <p>
                        Every traveler is unique, and so are our tours. Whether you're planning a family getaway, a romantic honeymoon, or an adventurous solo trip, our team of local experts crafts personalized itineraries tailored to your interests, budget, and pace.
                    </p>
                    <p>
                        We take pride in offering not just destinations, but genuine encounters with nature, culture, and people. Let us take care of all the details while you focus on creating memories that last a lifetime.
                    </p>
                </div>

                {/* Images with captions and card style */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
                    {[{ src: a4, label: "Business Registration" }, { src: a5, label: "Travel Guide License" }].map((item, index) => (
                        <div key={index} className="bg-white/30 dark:bg-gray-800/30 backdrop-blur-md border border-gray-200 dark:border-gray-700 rounded-2xl shadow-lg overflow-hidden p-3 text-center">
                            <img
                                src={item.src}
                                alt={item.label}
                                className="w-full h-[300px] object-cover rounded-xl shadow-md hover:scale-105 transition-transform duration-300 cursor-pointer"
                                onClick={() => setSelectedImage(item.src)}
                            />
                            <p className="mt-3 text-base font-medium text-gray-800 dark:text-gray-300">
                                {item.label}
                            </p>
                        </div>
                    ))}
                </div>

                {/* Highlighted Message Card */}
                <div className="mt-12 text-center">
                    <div className="inline-block bg-gradient-to-r from-green-100 via-yellow-50 to-green-100 dark:from-green-800 dark:to-green-700 text-gray-900 dark:text-white px-6 py-4 rounded-2xl shadow-md border border-green-300 dark:border-green-500 max-w-3xl mx-auto text-lg font-medium">
                        Dear Sir/Madam,<br />
                        We offer you a selection of <span className="font-semibold text-green-700 dark:text-yellow-300">high-quality and affordable Ayurvedic and tourist hotels</span> of your choice, anywhere in <span className="font-semibold text-green-700 dark:text-yellow-300">Sri Lanka</span>.
                    </div>
                </div>
            </div>

            {/* Modal for enlarged image */}
            {selectedImage && (
                <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4">
                    <div className="relative max-w-3xl w-full">
                        <button
                            onClick={() => setSelectedImage(undefined)}
                            className="absolute top-2 right-2 text-white text-3xl font-bold hover:text-red-500"
                        >
                            &times;
                        </button>
                        <img
                            src={selectedImage}
                            alt="Enlarged"
                            className="w-full h-auto max-h-[90vh] rounded-lg object-contain"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default AboutDetails;
